import styled from 'styled-components';

import { Color } from '../../shared/constants/Colors';
import { MediaQuery } from '../../shared/constants/Styles';

export const HorizontalLine = styled.span`
  padding-top: 60px;
  border-bottom: 1px solid ${Color.MYSTIC};
  display: block;
  margin: 0 auto;

  ${MediaQuery.M_AND_DOWN} {
    display: none;
  }
`;

export const Container = styled.div`
  max-width: 650px;
  margin: auto;
  padding: 30px 0 100px 0;
`;
